module.exports = __webpack_public_path__ + "img/live-chat.e4fb5387.png";